import { KlarnaComponent } from '../components/buyNowPayLater/klarnaComponent';
import { AffirmComponent } from '../components/buyNowPayLater/affirmComponent';

export const BuyNowPayLater = {
	AffirmComponent,
	KlarnaComponent
};
